import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Albaran/editAlbaran`, method: 'POST', body: values, token: token})
}
